import { render, staticRenderFns } from "./autocomplete-afm.vue?vue&type=template&id=49f24af6&scoped=true"
import script from "./autocomplete-afm.vue?vue&type=script&lang=js"
export * from "./autocomplete-afm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f24af6",
  null
  
)

export default component.exports